import { render, staticRenderFns } from "./addressAdd.vue?vue&type=template&id=4d34dbf2&scoped=true&"
import script from "./addressAdd.vue?vue&type=script&lang=js&"
export * from "./addressAdd.vue?vue&type=script&lang=js&"
import style0 from "./addressAdd.vue?vue&type=style&index=0&id=4d34dbf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d34dbf2",
  null
  
)

export default component.exports